import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Animation, AnimationController, IonFooter, IonNav } from '@ionic/angular';
import { IAltHesap, IKasaBanka, IMasrafMerkezi, IOdemeAl, OdemeAlFilter } from '@models/finance';
import { FinanceService } from '@services/apis/finance.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-odeme-al',
  templateUrl: './odeme-al.component.html',
  styleUrls: ['./odeme-al.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class OdemeAlComponent implements OnInit {
  @Input() odemeAl: IOdemeAl;
  @ViewChild(IonFooter, { read: ElementRef }) footer: ElementRef;

  public odemeAlFilter: OdemeAlFilter;
  public altHesaplar: IAltHesap[];
  public masrafMerkezi: IMasrafMerkezi[] = [{ masrafID: 1, masrafAdi: 'Masraf Merkezi 1', varsayilan: false }, { masrafID: 2, masrafAdi: 'Masraf Merkezi 2', varsayilan: false }];
  public kasaBanka: IKasaBanka[] = [{ hesapID: 1, hesapAdi: 'Kasa 1', hareketTurID: 54 }, { hesapID: 2, hesapAdi: 'Kasa 2', hareketTurID: 98 }];

  private footerFadeIn: Animation;
  private footerFadeOut: Animation;

  constructor(
    private financeService: FinanceService,
    private animationController: AnimationController,
    private nav: IonNav,
  ) { 
    this.odemeAlFilter = new OdemeAlFilter();
    this.odemeAlFilter.tahsilatTarihi = new Date().toDateString();
  }

  ngOnInit(): void {
    this.getAltHesaplar();
  }

  getAltHesaplar() {
    this.financeService.getAltHesaplar$().subscribe(response => {
      this.altHesaplar = response;
    });
  }

  transformAmount(event: Event, item: IAltHesap) {
    const value = (event.target as HTMLInputElement).value;
    item.tutar = Number(value);
  }

  ionViewWillEnter() {
    this.footerFadeIn = this.animationController
      .create()
      .addElement(this.footer.nativeElement)
      .fill('forwards')
      .duration(250)
      .easing('ease-out')
      .iterations(1)
      .fromTo('transform', 'translateY(150px)', 'translateY(0px)')
      .fromTo('opacity', '0', '1');

    this.footerFadeOut = this.animationController
      .create()
      .addElement(this.footer.nativeElement)
      .fill('forwards')
      .duration(250)
      .easing('ease-in')
      .iterations(1)
      .fromTo('transform', 'translateY(0px)', 'translateY(150px)')
      .fromTo('opacity', '1', '0');
  }

  ionViewDidEnter() {
    this.footerFadeIn.play();
  }

  ionViewWillLeave() {
    this.footerFadeOut.play();
  }

  saveForm() {
    if (this.odemeAlFilter.kasaBanka === undefined) {
      Swal.fire({
        title: 'Bilgi!',
        text: `Giriş Kasası/Bankası seçiniz.`,
        icon: 'info',
        confirmButtonText: 'Tamam',
        allowOutsideClick: false,
        heightAuto: false
      });
    } else {
      Swal.fire({
        toast: true,
        icon: 'success',
        title: 'Kaydetme Başarılı',
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: false,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
      }).then(() => {
        this.goback();
      });
    }
  }

  async goback() {
    this.nav.popToRoot();
  }

}
